import React, { useState } from "react";
import "../css/CuadroDeHonor.css";

// ==============================
// Imágenes
// ==============================

import Cuadro01 from "../img/cuadrohonor/cuadro01.jpg";
import Cuadro02 from "../img/cuadrohonor/cuadro02.png";
import Cuadro03 from "../img/cuadrohonor/cuadro03.png";
import Cuadro04 from "../img/cuadrohonor/cuadro04.jpeg";
import Cuadro05 from "../img/cuadrohonor/cuadro05.png";

// ==============================
// Meses del año
// ==============================

const meses = [
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

// ==============================
// Información del Cuadro de Honor
// Para agregar un reconocimiento,
// indica su mes y año.
// ==============================

const cuadroHonorData = [
    {
        id: 1,
        month: "Agosto",
        year: 2026,
        title: "Mejor Asistencia",
        subtitle: "Mes de Agosto 2026",
        description:
            "3° básico. Curso destacado por mantener una excelente asistencia durante el mes.",
        imageUrl: Cuadro01,
    },
    {
        id: 2,
        month: "Agosto",
        year: 2026,
        title: "Mejor Asistencia",
        subtitle: "Mes de Agosto 2026",
        description:
            "5° básico. Curso destacado por mantener una excelente asistencia durante el mes.",
        imageUrl: Cuadro02,
    },
    {
        id: 3,
        month: "Agosto",
        year: 2026,
        title: "Mejor Asistencia",
        subtitle: "Mes de Agosto 2026",
        description:
            "7° básico. Curso destacado por mantener una excelente asistencia durante el mes.",
        imageUrl: Cuadro03,
    },
    {
        id: 4,
        month: "Agosto",
        year: 2026,
        title: "Mejor Asistencia",
        subtitle: "Mes de Agosto 2026",
        description:
            "2° básico. Curso destacado por mantener una excelente asistencia durante el mes.",
        imageUrl: Cuadro04,
    },


     {
        id: 5,
        month:"Septiembre",
        year: 2026,
        title: "Mejor Asistencia",
        subtitle: "Mes de Septiembre 2026",
        description:
            "5° básico. Curso destacado por mantener una excelente asistencia durante el mes.",
         imageUrl: Cuadro05,
    },
];

// ==============================
// Componente
// ==============================

const CuadroDeHonor = () => {
    const [imagenSeleccionada, setImagenSeleccionada] =
        useState(null);

    const [mesSeleccionado, setMesSeleccionado] =
        useState("Septiembre");

    const [anioSeleccionado, setAnioSeleccionado] =
        useState(2026);

    // Filtrar reconocimientos por mes y año
    const reconocimientosFiltrados = cuadroHonorData.filter(
        (item) =>
            item.month === mesSeleccionado &&
            item.year === anioSeleccionado
    );

    const abrirImagen = (imagen) => {
        setImagenSeleccionada(imagen);
    };

    const cerrarImagen = () => {
        setImagenSeleccionada(null);
    };

    // Cerrar imagen con la tecla Escape
    React.useEffect(() => {
        const manejarTeclado = (e) => {
            if (e.key === "Escape") {
                cerrarImagen();
            }
        };

        window.addEventListener("keydown", manejarTeclado);

        return () => {
            window.removeEventListener(
                "keydown",
                manejarTeclado
            );
        };
    }, []);

    return (
        <section
            id="cuadrohonor-component"
            className="esc-cuadrohonor-section"
        >
            <div className="esc-cuadrohonor-container">

                {/* Título principal */}

                <h2 className="esc-cuadrohonor-title">
                    Cuadro de Honor
                </h2>

                <p className="esc-cuadrohonor-subtitle">
                    En este espacio destacamos el esfuerzo, la
                    dedicación y los logros de nuestros estudiantes
                    en las distintas actividades desarrolladas
                    durante el año escolar.
                </p>

                {/* Selector de año */}

                <div className="esc-cuadrohonor-year">
                    <label htmlFor="esc-cuadrohonor-anio">
                        Año escolar:
                    </label>

                    <select
                        id="esc-cuadrohonor-anio"
                        value={anioSeleccionado}
                        onChange={(e) =>
                            setAnioSeleccionado(
                                Number(e.target.value)
                            )
                        }
                    >
                        <option value={2026}>2026</option>
                        <option value={2027}>2027</option>
                        <option value={2028}>2028</option>
                    </select>
                </div>

                {/* Selector de meses */}

                <div className="esc-cuadrohonor-months">
                    <h3 className="esc-cuadrohonor-months-title">
                        Selecciona el mes
                    </h3>

                    <div
                        className="esc-cuadrohonor-months-list"
                        role="group"
                        aria-label="Mes del Cuadro de Honor"
                    >
                        {meses.map((mes) => (
                            <button
                                key={mes}
                                type="button"
                                className={`esc-cuadrohonor-month-btn ${
                                    mesSeleccionado === mes
                                        ? "activo"
                                        : ""
                                }`}
                                aria-pressed={
                                    mesSeleccionado === mes
                                }
                                onClick={() =>
                                    setMesSeleccionado(mes)
                                }
                            >
                                {mes}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Mes seleccionado */}

                <div className="esc-cuadrohonor-periodo">
                    <span className="esc-cuadrohonor-periodo-linea" />
                    <h3>
                        {mesSeleccionado} {anioSeleccionado}
                    </h3>
                    <span className="esc-cuadrohonor-periodo-linea" />
                </div>

                {/* Tarjetas de reconocimientos */}

                {reconocimientosFiltrados.length > 0 ? (
                    <div className="esc-cuadrohonor-grid">
                        {reconocimientosFiltrados.map((item) => (
                            <article
                                key={item.id}
                                className="esc-cuadrohonor-card"
                            >
                                <div className="esc-cuadrohonor-header">
                                    {item.title}
                                </div>

                                <div className="esc-cuadrohonor-subheader">
                                    {item.subtitle}
                                </div>

                                <div
                                    className="esc-cuadrohonor-image-wrapper"
                                    onClick={() =>
                                        abrirImagen(item.imageUrl)
                                    }
                                    onKeyDown={(e) => {
                                        if (
                                            e.key === "Enter" ||
                                            e.key === " "
                                        ) {
                                            e.preventDefault();
                                            abrirImagen(item.imageUrl);
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`Ampliar imagen: ${item.title}`}
                                >
                                    <img
                                        src={item.imageUrl}
                                        alt={`${item.title} - ${item.description}`}
                                        className="esc-cuadrohonor-image"
                                        loading="lazy"
                                    />

                                    <div className="esc-cuadrohonor-overlay">
                                        <div className="esc-cuadrohonor-zoom">
                                            🔍
                                        </div>
                                    </div>
                                </div>

                                <div className="esc-cuadrohonor-description">
                                    {item.description}
                                </div>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className="esc-cuadrohonor-empty">
                        <div className="esc-cuadrohonor-empty-icon">
                            🏆
                        </div>

                        <h3>
                            Próximamente: Cuadro de Honor
                        </h3>

                        <p>
                            Aún no hay reconocimientos publicados
                            para {mesSeleccionado} de {anioSeleccionado}.
                        </p>

                        <p>
                            ¡Pronto destacaremos los logros de
                            nuestros estudiantes!
                        </p>
                    </div>
                )}

            </div>

            {/* Imagen ampliada */}

            {imagenSeleccionada && (
                <div
                    className="esc-cuadrohonor-modal"
                    onClick={cerrarImagen}
                    role="presentation"
                >
                    <button
                        type="button"
                        className="esc-cuadrohonor-close"
                        onClick={cerrarImagen}
                        aria-label="Cerrar imagen ampliada"
                    >
                        ✕
                    </button>

                    <img
                        src={imagenSeleccionada}
                        alt="Imagen ampliada del Cuadro de Honor"
                        className="esc-cuadrohonor-modal-image"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </section>
    );
};

export default CuadroDeHonor;